// extracted by mini-css-extract-plugin
module.exports = {"icon":"_40059ea","pokerIcon":"_ed4cd03","deshIcon":"_183ff14"};